import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

export default function Regulamin() {
    const navigate = useNavigate();

    return (
        <div className="bg-light min-vh-100 py-5">
            <div className="container py-5" style={{ maxWidth: '820px' }}>

                {/* Back button */}
                <button
                    className="btn btn-sm btn-outline-secondary rounded-pill px-3 mb-5 d-inline-flex align-items-center gap-2"
                    onClick={() => navigate(-1)}
                >
                    <FontAwesomeIcon icon={faArrowLeft} /> Wróć
                </button>

                <h1 className="display-5 fw-bold mb-2">Regulamin</h1>
                <p className="text-secondary mb-5">Ostatnia aktualizacja: 25 lutego 2025 r.</p>

                <div className="d-flex flex-column gap-5">

                    <section>
                        <h2 className="h5 fw-bold mb-3">§1. Postanowienia ogólne</h2>
                        <ol className="text-secondary d-flex flex-column gap-2">
                            <li>Niniejszy Regulamin określa zasady korzystania z aplikacji webowej <strong>SayQ</strong> dostępnej pod adresem <strong>queroapp.pl</strong> (dalej: „Serwis" lub „Aplikacja").</li>
                            <li>Operatorem Serwisu jest <strong>Mateusz Krosnowski</strong>, e-mail: <a href="mailto:kontakt@queroapp.pl" className="text-primary">kontakt@queroapp.pl</a> (dalej: „Operator").</li>
                            <li>Korzystanie z Serwisu jest równoznaczne z akceptacją niniejszego Regulaminu.</li>
                            <li>Regulamin jest dostępny nieodpłatnie pod adresem <strong>queroapp.pl/regulamin</strong>.</li>
                        </ol>
                    </section>

                    <section>
                        <h2 className="h5 fw-bold mb-3">§2. Opis usługi</h2>
                        <ol className="text-secondary d-flex flex-column gap-2">
                            <li>SayQ to aplikacja webowa umożliwiająca organizowanie interaktywnych sesji Q&amp;A, ankiet i głosowań podczas wydarzeń na żywo.</li>
                            <li>Aplikacja przeznaczona jest dla organizatorów wydarzeń (<strong>Konto Organizatora</strong>) oraz uczestników tych wydarzeń (<strong>Goście</strong>).</li>
                            <li>Goście korzystają z Aplikacji bez rejestracji, wyłącznie za pośrednictwem kodu QR lub linku wygenerowanego przez Organizatora.</li>
                            <li>Operator zastrzega sobie prawo do zmiany funkcjonalności Serwisu, jego wyglądu oraz zakresu oferowanych usług.</li>
                        </ol>
                    </section>

                    <section>
                        <h2 className="h5 fw-bold mb-3">§3. Konto Organizatora</h2>
                        <ol className="text-secondary d-flex flex-column gap-2">
                            <li>Założenie Konta Organizatora wymaga podania adresu e-mail oraz hasła.</li>
                            <li>Konto zakładane jest na czas nieokreślony, z możliwością usunięcia przez Organizatora w dowolnym momencie.</li>
                            <li>Organizator zobowiązuje się do nieudostępniania danych logowania osobom trzecim.</li>
                            <li>Jeden adres e-mail może być przypisany tylko do jednego konta.</li>
                            <li>Operator może zawiesić lub usunąć konto w przypadku naruszenia Regulaminu.</li>
                        </ol>
                    </section>

                    <section>
                        <h2 className="h5 fw-bold mb-3">§4. Plany i opłaty</h2>
                        <ol className="text-secondary d-flex flex-column gap-2">
                            <li>Operator oferuje bezpłatny okres testowy wynoszący <strong>2 dni</strong> od daty rejestracji, w którym Organizator ma dostęp do pełnych funkcjonalności Aplikacji.</li>
                            <li>Po zakończeniu okresu testowego dostęp do zaawansowanych funkcji wymaga wykupienia licencji. Warunki i cennik dostępne są na stronie Serwisu lub po kontakcie z Operatorem.</li>
                            <li>Wykupienie licencji następuje na podstawie indywidualnego zamówienia. Operator wystawi fakturę VAT na żądanie.</li>
                            <li>Opłaty nie podlegają zwrotowi po skorzystaniu z usługi, chyba że bezwzględnie obowiązujące przepisy prawa stanowią inaczej.</li>
                        </ol>
                    </section>

                    <section>
                        <h2 className="h5 fw-bold mb-3">§5. Zasady korzystania z Serwisu</h2>
                        <p className="text-secondary mb-2">Zabrania się:</p>
                        <ul className="text-secondary d-flex flex-column gap-2">
                            <li>publikowania treści nielegalnych, obraźliwych, nienawistnych lub naruszających prawa osób trzecich;</li>
                            <li>wprowadzania w błąd Operatora lub innych użytkowników;</li>
                            <li>podejmowania prób nieuprawnionego dostępu do systemów Operatora;</li>
                            <li>używania Aplikacji w celach spamowania, masowej wysyłki treści lub działalności niezgodnej z prawem;</li>
                            <li>ingerowania w działanie Aplikacji, w tym stosowania automatycznych narzędzi do nadmiernego obciążania serwera.</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="h5 fw-bold mb-3">§6. Prawa własności intelektualnej</h2>
                        <ol className="text-secondary d-flex flex-column gap-2">
                            <li>Wszelkie prawa do Aplikacji, jej wyglądu, kodu i marki SayQ należą do Operatora.</li>
                            <li>Korzystanie z Serwisu nie przenosi na Organizatora ani Gości żadnych praw własności intelektualnej.</li>
                            <li>Treści tworzone przez Organizatora (nazwy wydarzeń, pytania, wyniki ankiet) pozostają własnością Organizatora. Operator nie rości do nich żadnych praw.</li>
                            <li>Organizator udziela Operatorowi nieodpłatnej, niewyłącznej licencji na przechowywanie i wyświetlanie tych treści wyłącznie w celu świadczenia usługi.</li>
                        </ol>
                    </section>

                    <section>
                        <h2 className="h5 fw-bold mb-3">§7. Odpowiedzialność</h2>
                        <ol className="text-secondary d-flex flex-column gap-2">
                            <li>Operator nie ponosi odpowiedzialności za treści zamieszczane przez Organizatorów ani za pytania zadawane przez uczestników wydarzeń.</li>
                            <li>Operator nie gwarantuje nieprzerwanego działania Serwisu i nie odpowiada za przerwy techniczne wynikające z konserwacji, awarii lub działania siły wyższej.</li>
                            <li>Operator dokłada wszelkich starań, aby zapewnić poprawne działanie Aplikacji, ale nie odpowiada za szkody wynikające z jej użytkowania lub niedostępności.</li>
                            <li>Organizator ponosi pełną odpowiedzialność za korzystanie z Aplikacji w ramach swojego konta oraz za treści udostępniane uczestnikom.</li>
                        </ol>
                    </section>

                    <section>
                        <h2 className="h5 fw-bold mb-3">§8. Ochrona danych osobowych</h2>
                        <p className="text-secondary">
                            Zasady przetwarzania danych osobowych opisane są w <a href="/polityka-prywatnosci" className="text-primary">Polityce Prywatności</a>, stanowiącej integralną część niniejszego Regulaminu.
                        </p>
                    </section>

                    <section>
                        <h2 className="h5 fw-bold mb-3">§9. Rozwiązanie umowy i usunięcie konta</h2>
                        <ol className="text-secondary d-flex flex-column gap-2">
                            <li>Organizator może w dowolnym momencie usunąć swoje konto, kontaktując się z Operatorem pod adresem <a href="mailto:kontakt@queroapp.pl" className="text-primary">kontakt@queroapp.pl</a>.</li>
                            <li>Operator może rozwiązać umowę i usunąć konto z 14-dniowym wypowiedzeniem w przypadku nieużywania konta przez 24 miesiące.</li>
                            <li>Operator może natychmiastowo usunąć konto w przypadku rażącego naruszenia Regulaminu.</li>
                        </ol>
                    </section>

                    <section>
                        <h2 className="h5 fw-bold mb-3">§10. Zmiany Regulaminu</h2>
                        <ol className="text-secondary d-flex flex-column gap-2">
                            <li>Operator zastrzega sobie prawo do zmiany Regulaminu.</li>
                            <li>O zmianach Organizatorzy zostaną powiadomieni z co najmniej 14-dniowym wyprzedzeniem, drogą e-mail lub poprzez komunikat w Serwisie.</li>
                            <li>Dalsze korzystanie z Serwisu po dacie wejścia w życie zmian jest równoznaczne z ich akceptacją.</li>
                        </ol>
                    </section>

                    <section>
                        <h2 className="h5 fw-bold mb-3">§11. Postanowienia końcowe</h2>
                        <ol className="text-secondary d-flex flex-column gap-2">
                            <li>W sprawach nieuregulowanych niniejszym Regulaminem stosuje się przepisy prawa polskiego, w szczególności Kodeksu cywilnego oraz ustawy o świadczeniu usług drogą elektroniczną.</li>
                            <li>Ewentualne spory będą rozstrzygane przez sąd właściwy dla siedziby Operatora.</li>
                            <li>Regulamin wchodzi w życie z dniem 25 lutego 2025 r.</li>
                        </ol>
                    </section>

                    <section>
                        <h2 className="h5 fw-bold mb-3">Kontakt</h2>
                        <p className="text-secondary">
                            📧 <a href="mailto:kontakt@queroapp.pl" className="text-primary">kontakt@queroapp.pl</a><br />
                            🌐 <a href="https://queroapp.pl" className="text-primary" target="_blank" rel="noopener noreferrer">queroapp.pl</a>
                        </p>
                    </section>

                </div>
            </div>
        </div>
    );
}
